import aclMeta, { userTypePageAcl } from '@/router/consts'
import { ccdRouteNames, standaloneWpRouteNames } from '@/utils/consts'

const prefix = '/vendors'
const userTypeAcl = userTypePageAcl.vendor

const PublicLogin = () => import('@/pages/PublicLogin')

/* sub-routes */
const VendorHome = () => import('@/pages/vendors/Home')

const VendorSettings = () => import('@/pages/vendors/Settings')

const TenderDetails = () => import('@/pages/tenders/Edit')
const TenderDetailsView = () => import('@/pages/tenders/View')
const TenderBidView = () => import('@/pages/tenders/Bid')

const TenderAddendumDetailsView = () => import('@/pages/tenders/addendum/View')
const TenderAddendumDetails = () => import('@/pages/tenders/addendum/Edit')

const Addendum = () => import('@/modules/tenders/review/Addendum')
const AnalysisRecos = () => import('@/modules/tenders/review/AnalysisRecos')
const Comparison = () => import('@/pages/tenders/Comparison')
const HealthCheck = () => import('@/modules/tenders/review/HealthCheck')
const QueryStatus = () => import('@/modules/tenders/review/QueryStatus')
const Summary = () => import('@/pages/tenders/Summary')

const ContractorTermsOfUse = () => import('@/pages/vendors/TermsOfUse')

const ProjectDetail = () => import('@/pages/projects/ProjectDetail')

const CreateWorkPermit = () => import('@/modules/workPermits/CreateWorkPermit')
const StandaloneWp = () => import('@/modules/workPermits/StandaloneWp')

const ExternalUserProfile = () => import('@/pages/ExternalUserProfile')

const CcdContacts = () => import('@/modules/contacts/ContactsIndex')
const CcdContactDetail = () => import('@/pages/ccd/ContactDetail')

const paths = {
  routes: [
    /**
     * Vendors view, path starts with vendors
     */
    { path: '/', redirect: { name: 'vendorHome' } },
    { path: '/dashboard', component: VendorHome, name: 'vendorHome' },
    { path: '/terms-of-use', name: 'contractorTermsOfUse', component: ContractorTermsOfUse, meta: { userTypeAcl: () => true, showHeaderFooter: false } },
    { path: '/settings', name: 'vendorSettings', component: VendorSettings },
    { path: '/login', name: 'vendorLogin', component: PublicLogin, meta: { userTypeAcl: () => true } },
    { path: '/tender-bid/:id', name: 'tenderBidView', component: TenderBidView, meta: { acl: aclMeta.contractorTender } },
    { path: '/tender/review/:id', name: 'tenderDetailsViewExt', component: TenderDetailsView, meta: { acl: aclMeta.contractorReviewTender } },
    { path: '/tender/edit/:id', name: 'tenderDetailsExt', component: TenderDetails, meta: { acl: aclMeta.contractorReviewTender } },
    { path: '/tender/addendum/:id', name: 'tenderAddendumDetailsViewExt', component: TenderAddendumDetailsView, meta: { acl: aclMeta.contractorReviewTender } },
    { path: '/tender/addendum/edit/:id', name: 'tenderAddendumDetailsExt', component: TenderAddendumDetails, meta: { acl: aclMeta.contractorReviewTender } },
    { path: '/comparison/:id', name: 'tenderComparisonExt', component: Comparison, meta: { acl: aclMeta.contractorReviewTender } },
    { path: '/summary/:id',
      name: 'tenderSummaryExt',
      component: Summary,
      redirect: `/summary/:id/health-check`,
      meta: { acl: aclMeta.contractorReviewTender },
      children: [
        {
          path: 'analysis-recos',
          name: 'analysisRecosExt',
          component: AnalysisRecos,
        },
        {
          path: 'health-check',
          name: 'healthCheckExt',
          component: HealthCheck,
        },
        {
          path: 'addendum',
          name: 'addendumSummaryExt',
          component: Addendum,
        },
        {
          path: 'query',
          name: 'queryStatusExt',
          component: QueryStatus,
        },
      ],
    },
    { path: '/projects/:id', name: 'vendorProjectDetail', component: ProjectDetail, meta: { acl: aclMeta.contractorProject } },
    /**
     * Work Permit
     */
    { path: '/work-permits/:id', name: 'vendorCreateWorkPermit', component: CreateWorkPermit },
    { path: '/standalone-wp/:id', name: standaloneWpRouteNames.vendorStandaloneWp, component: StandaloneWp },
    /**
     * Profile
     */
    { path: '/profile', name: 'vendorProfile', component: ExternalUserProfile },
    { path: '/contacts', name: ccdRouteNames.vendorContacts, component: CcdContacts },
    { path: '/ccdcontacts/create', name: ccdRouteNames.vendorCcdContactCreate, component: CcdContactDetail },
    { path: '/ccdcontacts/detail/:id', name: ccdRouteNames.vendorCcdContactView, component: CcdContactDetail },
    { path: '/ccdcontacts/edit/:id', name: ccdRouteNames.vendorCcdContactEdit, component: CcdContactDetail },
  ],
}

export default { prefix, paths, userTypeAcl }
